import { qrDataUrl } from "@/shared/utils/qrDataUrl";

/**
 * Render a PIX EMV / copia-e-cola payload as a QR PNG data URL. The payments runtime returns the raw EMV
 * string (`qr_code_payload`), not an image — every consumer (wallets deposit modal, /app/payins success
 * screen, PDFs via `payload_b64`) renders it client-side through this single helper so the QR options never
 * drift (they live in the shared `qrDataUrl`). Returns null on failure.
 */
export async function pixQrDataUrl(payload: string): Promise<string | null> {
  return qrDataUrl(payload);
}
